import { render, staticRenderFns } from "./supplier-credit.vue?vue&type=template&id=12591be3&scoped=true"
import script from "./supplier-credit.vue?vue&type=script&lang=js"
export * from "./supplier-credit.vue?vue&type=script&lang=js"
import style0 from "./supplier-credit.vue?vue&type=style&index=0&id=12591be3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12591be3",
  null
  
)

export default component.exports